import { React, useState, useEffect } from "react";
import "./ReportStyle.css";
import { v4 as uuid } from "uuid";
import { useNavigate } from "react-router-dom";


function BasicTable({ viewData, setShowTableview }) {



  const [matchValue, setMatchValue] = useState(false);
  const [policyNo, setPolicyNo] = useState("");
  const [policyType, setPolicyType] = useState("ALL");

  const [StatusResult, setStatusResult] = useState({});


  let eiaNumber = sessionStorage.getItem("eiaNo");
  let ployNumber = sessionStorage.getItem("policyNo");
  let comapanyCode = sessionStorage.getItem("companyCode");
  let policyTy = sessionStorage.getItem("policyTy");



  const Navigate = useNavigate()

  // let StatusResult = {}



  // useEffect(() => {
  const Data = viewData;



  const policyTypeForresponse = "L"

  let typrValue1 = policyTypeForresponse == JSON.parse(policyTy) ? Data?.insaLifePolicyDetails : Data?.insaHealthPolicyDetails
  let typrValue2 = policyTypeForresponse == JSON.parse(policyTy) ? Data?.insunetLifePolicyDetails : Data?.insunetHealthPolicyDetails



  const data1 = Object.assign({}, typrValue1, typrValue1?.bankAccountDetails?.[0], typrValue1?.nomineeDetails?.[0], typrValue1?.lifeInsuredDetails?.[0])
  const data2 = Object.assign({}, typrValue2, typrValue2?.bankAccountDetails?.[0], typrValue2?.nomineeDetails?.[0], typrValue1?.lifeInsuredDetails?.[0])


  // console.log("da", data1)
  const newArrayForView = []

  for (let item in data1) {
    newArrayForView.push(item)
  }

  useEffect(() => {

    if (data1) {
      let temp = {};
      // console.log("render")
      for (let key in data1) {

        if (data1[key].includes("not available") && data2[key].includes("not available")) {
          temp[key] = "Not available in Insa/Insunet"
        }
        else if (data1[key].includes("not available")) {
          temp[key] = "Not available in Insa"
        }
        else if (data2[key].includes("not available")) {
          temp[key] = "Not available in Insunet"
        }

        else if (data1[key] === data2[key]) {
          // setStatusResult(Object.assign({}, StatusResult, { [key]: "33" }))

          // setStatusResult(prevState => ({
          //   ...prevState,
          temp[key] = "Matched"
          // }));
          // let temp = StatusResult

          // temp[key] = "Match"
          // setStatusResult({key : "match"})
        } else {
          // let temp = StatusResult

          // temp[key] = "Not Match"
          // setStatusResult(temp)

          // setStatusResult(prevState => ({
          //   ...prevState,
          //   [key]: "Match"
          // }));
          temp[key] = "Not Matched"

          // setStatusResult(Object.assign({}, StatusResult, { [key]: "33" }))
        }
      }

      // console.log("ss", StatusResult, data1)

      setStatusResult(temp)
    }
  }, [viewData])

  let resultKey = Object.keys(data1)


  // console.log(typeof resultKey, "result")


  const finalSubmit = async (item) => {
    // e.preventDefault();

    const BaseUrl = process.env.REACT_APP_API_URL;

    const UrlInsaMatch = "/riInsurerBulkService/v1/submitPolicyDetails";

    let myuuid = uuid();
    try {
      const response = await fetch(`${BaseUrl}${UrlInsaMatch}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          txnId: myuuid,
          timestamp: "2023-07-31T19:43:25.387994200",
          Source: {
            appType: "MOBILE",
            osVersion: "11",
            deviceId: "",
            deviceName: "Mymobile 52",
            deviceOS: "Android",
            appVersion: "2.0",
            clientIp: "0.0.0.0",
            origin: ""
          },
          Customer: {
            eiaNo: JSON.parse(eiaNumber),
            policyNo: JSON.parse(ployNumber),
            insuranceCompanyCode: JSON.parse(comapanyCode),
            // "matchedData":"\"matchedData\":{\"insaHealthPolicyDetails\":{\"agentBrokerCode\":\"\",\"agentBrokerName\":\"\",\"agentBrokerNumber\":\"\",\"certificateNumber\":\"\",\"coverInceptionDate\":\"\",\"email\":\"\",\"firstEnrollmentDate\":\"\",\"grossAmount\":\"\",\"groupPolicyNumber\":\"\",\"groupPolicyholderAddress\":\"\",\"groupPolicyholderName\":\"\",\"groupPolicyholderPincode\":\"\",\"insuranceCompanyName\":\"\",\"insuredAge\":\"\",\"insuredCertificateNo\":\"\",\"issuingOfficeAddress\":\"\",\"issuingOfficePincode\":\"\",\"lifeInsuredDetails\":[{\"lifeInsuredClientid\":\"\",\"lifeInsuredDob\":\"\",\"lifeInsuredGender\":\"\",\"lifeInsuredInceptionDate\":\"\",\"lifeInsuredName\":\"\",\"lifeInsuredNoClaimBonus\":\"\",\"lifeInsuredPed\":\"\",\"lifeInsuredRelationship\":\"\",\"lifeInsuredSumInsured\":\"\"}],\"mobileNumber\":\"\",\"modalPremiumAmount\":\"\",\"modeOfPayment\":\"\",\"noClaimBonus\":\"\",\"nomineeDetails\":[{\"nomineeAge\":\"\",\"nomineeDob\":\"\",\"nomineeName\":\"\",\"nomineeRelationship\":\"\"}],\"pinCode\":\"\",\"policyEndDate\":\"\",\"policyExpirySumInsured\":\"\",\"policyIssueDate\":\"\",\"policyNumber\":\"\",\"policyProductName\":\"\",\"policyStartDate\":\"\",\"policyType\":\"\",\"policyholderClientid\":\"\",\"policyholderDob\":\"\",\"policyholderGender\":\"\",\"policyholderName\":\"\",\"previousInsurer\":\"\",\"previousPolicies\":\"\",\"proposerName\":\"\",\"residentialAddress\":\"\",\"saCoverType\":\"\",\"safeguardSumAssured\":\"\",\"sumAssured\":\"\",\"title\":\"\"},\"insunetHealthPolicyDetails\":{\"agentBrokerCode\":\"\",\"agentBrokerName\":\"\",\"agentBrokerNumber\":\"\",\"certificateNumber\":\"\",\"coverInceptionDate\":\"\",\"email\":\"\",\"firstEnrollmentDate\":\"\",\"grossAmount\":\"\",\"groupPolicyNumber\":\"\",\"groupPolicyholderAddress\":\"\",\"groupPolicyholderName\":\"\",\"groupPolicyholderPincode\":\"\",\"insuranceCompanyName\":\"\",\"insuredAge\":\"\",\"insuredCertificateNo\":\"\",\"issuingOfficeAddress\":\"\",\"issuingOfficePincode\":\"\",\"lifeInsuredDetails\":[{\"lifeInsuredClientid\":\"\",\"lifeInsuredDob\":\"\",\"lifeInsuredGender\":\"\",\"lifeInsuredInceptionDate\":\"\",\"lifeInsuredName\":\"\",\"lifeInsuredNoClaimBonus\":\"\",\"lifeInsuredPed\":\"\",\"lifeInsuredRelationship\":\"\",\"lifeInsuredSumInsured\":\"\"}],\"mobileNumber\":\"\",\"modalPremiumAmount\":\"\",\"modeOfPayment\":\"\",\"noClaimBonus\":\"\",\"nomineeDetails\":[{\"nomineeAge\":\"\",\"nomineeDob\":\"\",\"nomineeName\":\"\",\"nomineeRelationship\":\"\"}],\"pinCode\":\"\",\"policyEndDate\":\"\",\"policyExpirySumInsured\":\"\",\"policyIssueDate\":\"\",\"policyNumber\":\"\",\"policyProductName\":\"\",\"policyStartDate\":\"\",\"policyType\":\"\",\"policyholderClientid\":\"\",\"policyholderDob\":\"\",\"policyholderGender\":\"\",\"policyholderName\":\"\",\"previousInsurer\":\"\",\"previousPolicies\":\"\",\"proposerName\":\"\",\"residentialAddress\":\"\",\"saCoverType\":\"\",\"safeguardSumAssured\":\"\",\"sumAssured\":\"\",\"title\":\"\"}},\"unMatchedData\":{\"insaHealthPolicyDetails\":{\"agentBrokerCode\":\"\",\"agentBrokerName\":\"\",\"agentBrokerNumber\":\"\",\"certificateNumber\":\"\",\"coverInceptionDate\":\"\",\"email\":\"\",\"firstEnrollmentDate\":\"\",\"grossAmount\":\"\",\"groupPolicyNumber\":\"\",\"groupPolicyholderAddress\":\"\",\"groupPolicyholderName\":\"\",\"groupPolicyholderPincode\":\"\",\"insuranceCompanyName\":\"\",\"insuredAge\":\"\",\"insuredCertificateNo\":\"\",\"issuingOfficeAddress\":\"\",\"issuingOfficePincode\":\"\",\"lifeInsuredDetails\":[{\"lifeInsuredClientid\":\"\",\"lifeInsuredDob\":\"\",\"lifeInsuredGender\":\"\",\"lifeInsuredInceptionDate\":\"\",\"lifeInsuredName\":\"\",\"lifeInsuredNoClaimBonus\":\"\",\"lifeInsuredPed\":\"\",\"lifeInsuredRelationship\":\"\",\"lifeInsuredSumInsured\":\"\"}],\"mobileNumber\":\"\",\"modalPremiumAmount\":\"\",\"modeOfPayment\":\"\",\"noClaimBonus\":\"\",\"nomineeDetails\":[{\"nomineeAge\":\"\",\"nomineeDob\":\"\",\"nomineeName\":\"\",\"nomineeRelationship\":\"\"}],\"pinCode\":\"\",\"policyEndDate\":\"\",\"policyExpirySumInsured\":\"\",\"policyIssueDate\":\"\",\"policyNumber\":\"\",\"policyProductName\":\"\",\"policyStartDate\":\"\",\"policyType\":\"\",\"policyholderClientid\":\"\",\"policyholderDob\":\"\",\"policyholderGender\":\"\",\"policyholderName\":\"\",\"previousInsurer\":\"\",\"previousPolicies\":\"\",\"proposerName\":\"\",\"residentialAddress\":\"\",\"saCoverType\":\"\",\"safeguardSumAssured\":\"\",\"sumAssured\":\"\",\"title\":\"\"},\"insunetHealthPolicyDetails\":{\"agentBrokerCode\":\"\",\"agentBrokerName\":\"\",\"agentBrokerNumber\":\"\",\"certificateNumber\":\"\",\"coverInceptionDate\":\"\",\"email\":\"\",\"firstEnrollmentDate\":\"\",\"grossAmount\":\"\",\"groupPolicyNumber\":\"\",\"groupPolicyholderAddress\":\"\",\"groupPolicyholderName\":\"\",\"groupPolicyholderPincode\":\"\",\"insuranceCompanyName\":\"\",\"insuredAge\":\"\",\"insuredCertificateNo\":\"\",\"issuingOfficeAddress\":\"\",\"issuingOfficePincode\":\"\",\"lifeInsuredDetails\":[{\"lifeInsuredClientid\":\"\",\"lifeInsuredDob\":\"\",\"lifeInsuredGender\":\"\",\"lifeInsuredInceptionDate\":\"\",\"lifeInsuredName\":\"\",\"lifeInsuredNoClaimBonus\":\"\",\"lifeInsuredPed\":\"\",\"lifeInsuredRelationship\":\"\",\"lifeInsuredSumInsured\":\"\"}],\"mobileNumber\":\"\",\"modalPremiumAmount\":\"\",\"modeOfPayment\":\"\",\"noClaimBonus\":\"\",\"nomineeDetails\":[{\"nomineeAge\":\"\",\"nomineeDob\":\"\",\"nomineeName\":\"\",\"nomineeRelationship\":\"\"}],\"pinCode\":\"\",\"policyEndDate\":\"\",\"policyExpirySumInsured\":\"\",\"policyIssueDate\":\"\",\"policyNumber\":\"\",\"policyProductName\":\"\",\"policyStartDate\":\"\",\"policyType\":\"\",\"policyholderClientid\":\"\",\"policyholderDob\":\"\",\"policyholderGender\":\"\",\"policyholderName\":\"\",\"previousInsurer\":\"\",\"previousPolicies\":\"\",\"proposerName\":\"\",\"residentialAddress\":\"\",\"saCoverType\":\"\",\"safeguardSumAssured\":\"\",\"sumAssured\":\"\",\"title\":\"\"}}"
            matchedData: JSON.stringify(StatusResult)
          }
        }
        ),
      });

      if (response.ok) {


        let jsonResponse = await response.json();

        let res = jsonResponse?.displayMesssage;
        // console.log(res)
        setShowTableview(false);
        alert(res)



      } else {
        const errorResponse = await response.json();
        setShowTableview(false);
        alert(`Error: ${errorResponse.errorDescription}`);

      }
    } catch (error) {
      // Handle network errors or any other exceptions
      console.error("Error:", error.message);
    }




  }


  const onMatch = (value) => {

    // StatusResult[value] = 'Matched'

    setStatusResult({ ...StatusResult, [value]: "Matched" })
  }
  const onNotMatch = (value) => {
    // StatusResult[value] = 'Not Matched'

    setStatusResult({ ...StatusResult, [value]: "Not Matched" })
  }

  const insaTable = () => {
    setShowTableview(false);
  }

  return (
    <div className="App">
      <table>
        <tr>
          <th className="table-head-card">Parameter</th>
          <th className="table-head-card" style={{ maxWidth: '200px', wordWrap: 'break-word' }}>Insunet Value</th>
          <th className="table-head-card" style={{ maxWidth: '200px', wordWrap: 'break-word' }}>InSa Value</th>
          <th className="table-head-card">Comparison Outcome</th>
          <th className="table-head-card">Action</th>
        </tr>
        {/* {resultKey.length} */}
        {resultKey.length && resultKey.map((val, index) => {
          return (
            <>
              {!["bankAccountDetails", "nomineeDetails", "lifeInsuredDetails"].includes(val) && <tr>
                <td className="table-head" >{val}</td>
                <td className="table-head-insu" style={{ maxWidth: '200px', wordWrap: 'break-word' }}>{!["bankAccountDetails", "nomineeDetails", "lifeInsuredDetails"].includes(val) ? data2[val] : ''}</td>
                <td className="table-head-insa" style={{ maxWidth: '200px', wordWrap: 'break-word' }}>{!["bankAccountDetails", "nomineeDetails", "lifeInsuredDetails"].includes(val) ? data1[val] : ''}</td>
                <td className="table-head-status">{StatusResult[val]}</td>
                <td className="table-head-card-match"><div className="match-func"><button onClick={() => onMatch(val)} className="match-btn">Match</button><button onClick={() => onNotMatch(val)} className="not-match-btn">Not Match</button></div></td>
              </tr>}
            </>
          )
        })}
      </table>
      <div className="btn-card-table"><div className="match-func-final"><button className="submit-btn" onClick={() => finalSubmit()}>Submit</button></div>
        <div className="match-func-final"><button className="submit-btn" onClick={insaTable}>Cancel</button></div></div>

    </div>
  );
}

export default BasicTable;

